'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _languageCommon = require('@wh/language-common');

var _languageCommon2 = _interopRequireDefault(_languageCommon);

var _inputPassword = require('./input-password');

var _inputPassword2 = _interopRequireDefault(_inputPassword);

var _actions = require('../login-component/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = (0, _reselect.createStructuredSelector)({
    language: _languageCommon2.default
});


var mapDispatchToProps = {
    trackingEvent: _actions.trackingEvent
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_inputPassword2.default);
//# sourceMappingURL=Container.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/input-password/Container.js
// module id = 482
// module chunks = 0